module.exports = __webpack_public_path__ + "static/media/mall-image-6.9077eb41.png";